import { Filter } from '../groups-filters/groups-filters.interface';

export enum GroupMemberInterface {
  Team = 'team',
  Company = 'company',
  Brand = 'brand',
  ExistingUser = 'existingUser',
  EmailAddress = 'emailAddress',
}

export type GroupStatus = 'active' | 'archived';

export interface GroupInterface {
  id: string;
  name: string;
  description: string;
  status?: GroupStatus;
  memberType: GroupMemberInterface;
  members: string[];
  createdAt?: string;
  updatedAt?: string;
}

export interface GetMembersParams {
  pagination: {
    page?: number;
    limit?: number;
    search?: string;
    selectedMembers?: string[];
  };
  filter?: {
    filters: Filter[];
    cacheId?: string;
  };
}
